// TODO: >>>> [QS-5465] Add GQL Partial
export const ExternalCalendarEventPartial = `
`;
